import { lastUpdateDateFormatter } from '../../../../utils';

type StrategyStatusProps = {
  status: string;
  lastUpdate?: string;
};

const StrategyStatus = ({ status, lastUpdate }: StrategyStatusProps) => {
  const STATUS_COLORS: any = {
    'NOT STARTED': 'bg-meo-grey',
    'IN PROGRESS': 'bg-meo-blue',
    FINALIZED: 'bg-meo-green',
    OUTDATED: 'bg-meo-red',
    DEFAULT: 'bg-meo-grey',
  };

  const statusColor = STATUS_COLORS[status?.toUpperCase() || 'DEFAULT'];

  return (
    <section
      className={`${statusColor} rounded-lg px-4 py-1 bg-opacity-25 uppercase flex justify-between`}
    >
      <span>
        STRATEGY STATUS // <b>{status}</b>
      </span>
      <span>
        LAST STRATEGY UPDATE //{' '}
        <b>
          {status?.toUpperCase() === 'FINALIZED' || status?.toUpperCase() === 'OUTDATED'
            ? lastUpdateDateFormatter(lastUpdate || null)
            : 'NEVER'}
        </b>
      </span>
    </section>
  );
};

export default StrategyStatus;
